const DOMAINS = ["gmail.com", "yahoo.com", "yahoo.it", "hotmail.com", "hotmail.it", "outlook.com", "outlook.it",
  "libero.it", "virgilio.it", "tiscali.it", "alice.it", "tim.it", "live.com", "live.it", "icloud.com", "me.com",
  "fastwebnet.it", "email.it", "pec.it", "aruba.it", "proton.me", "protonmail.com"];
const TLDS = ["com", "it", "net", "org", "eu", "me", "info", "biz", "ch", "de", "fr", "es", "uk", "co.uk"];

const dist = (a, b) => {
  const d = Array.from({ length: a.length + 1 }, (_, i) => [i, ...Array(b.length).fill(0)]);
  for (let j = 1; j <= b.length; j++) d[0][j] = j;
  for (let i = 1; i <= a.length; i++)
    for (let j = 1; j <= b.length; j++)
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
  return d[a.length][b.length];
};

// Returns a corrected address if the domain looks mistyped, otherwise null.
export function suggestEmail(email) {
  const m = /^([^@\s]+)@([^@\s]+\.[^@\s]+)$/.exec((email || "").trim().toLowerCase());
  if (!m) return null;
  const [, user, domain] = m;
  if (DOMAINS.includes(domain)) return null;
  const near = DOMAINS.find((d) => dist(domain, d) <= 2);
  if (near) return `${user}@${near}`;
  const dot = domain.lastIndexOf(".");
  const base = domain.slice(0, dot), tld = domain.slice(dot + 1);
  if (TLDS.includes(tld)) return null;
  const sameBase = DOMAINS.find((d) => d.slice(0, d.lastIndexOf(".")) === base);
  if (sameBase) return `${user}@${sameBase}`;
  const nearTld = TLDS.find((t) => dist(tld, t) === 1);
  return nearTld ? `${user}@${base}.${nearTld}` : null;
}
